const ArticleCard = (element) => {
  const images = element.querySelectorAll("img");

  const addOnLoadListeners = () => {
    if (images?.[0]) {
      images.forEach((img) => {
        img.addEventListener("load", () => {
          img.classList.add("loaded");
        });

        if (img?.complete) {
          img.classList.add("loaded");
        }
      });
    }
  };

  const main = () => {
    addOnLoadListeners();
  };

  main();
};

export default ArticleCard;
